// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a544eb50","453":"a2f15ac3","732":"d704b8c7","977":"11ce1303"}[chunkId] + ".chunk.js";
};